export const SHOWN = 1
export const CLOSING = 2
